export const pathLayerAsLine = (accParam, edgeTypeParam) => ({
  type: 'line',
  filter:[
    'all',
    ['!=', ['get', edgeTypeParam], 'bus'],
    ['!=', ['get', edgeTypeParam], 'ferry'],
  ],
  paint: {
    'line-color': [
      'case',
      ['==', ['get', accParam], 0], '#22b32b',
      ['==', ['get', accParam], 1], '#d4901e',
      ['==', ['get', accParam], 2], '#f00025',
      ['==', ['get', accParam], 3], '#686868',
      '#222222'
    ],
    'line-dasharray':[
      1, 3
    ],
    'line-width': 3
  },
  layout: {
    'line-cap': 'round',
    'line-join': 'round'
  }
});